import React from 'react'
import AppRouter from './Config/Router'
function App() {
  return (
    <>
  <AppRouter />
   </>
  )
}

export default App
